export enum FeedbackCollectorModalVariant {
	POSITIVE = 'positive',
	NEGATIVE = 'negative',
}
